import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import styles from './FundingBreakdownProgressBar.module.scss';
import { getProgressBarColor } from '../../utils/colorUtils';
import computeProgressSegments from './utils/computeProgressSegments';
export const FundingBreakdownProgressBar = ({ fundingOverview, }) => {
    const { segments, totalWidth } = useMemo(() => computeProgressSegments(fundingOverview?.ruleGroups || [], Number(fundingOverview?.ruleTotals?.totalLimit || 0)), [fundingOverview]);
    const totalCards = (fundingOverview?.ruleGroups || []).length;
    return (_jsx("div", { className: styles.progressBarContainer, children: _jsxs("div", { className: styles.progressBar, children: [segments.map((segment, idx) => (_jsx("div", { className: `${styles.progressFill} ${getProgressBarColor(idx, totalCards)}`, style: {
                        ['--progress-left']: `${segment.left}%`,
                        ['--progress-width']: `${segment.width}%`,
                        ['--progress-gap']: '0.5px',
                    } }, segment.key))), segments.map((segment, idx) => {
                    const isLast = idx === segments.length - 1;
                    const shouldShowDivider = !isLast || (isLast && totalWidth < 99.9);
                    if (!shouldShowDivider)
                        return null;
                    const dividerLeft = segment.left + segment.width - 0.03;
                    return (_jsx("div", { className: styles.dividerContainer, style: { ['--divider-left']: `${dividerLeft}%` }, children: _jsx("div", { className: `${styles.divider} ${isLast ? styles.lastDividerWidth : ''}` }) }, `divider-${segment.key}`));
                })] }) }));
};
export default FundingBreakdownProgressBar;
